import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, Box, Container, Typography, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Sensor from './images/sensor_front.png';

const StyledImage = styled('img')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '93%',
});

export default function HeroBlock() {
  const [open, setOpen] = useState(false);

  return (
    <Container sx={{ px: { lg: '0!important', xs: '32px!important' } }}>
      <Box sx={{ mt: 5, mb: 7, display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'space-between', flexDirection: { md: 'row', xs: 'column-reverse' } }}>
        <Box sx={{ maxWidth: '650px', width: '80vw' }}>
          <Typography
            variant="h2"
            sx={{ fontFamily: 'ZalandoSans', fontWeight: '800', fontSize: '60px !important', lineHeight: '1' }}
          >
            VPSi is a cutting- edge air quality monitoring system.
          </Typography>
          <Typography variant="h4" sx={{ mt: 2, mb: 4, fontFamily: 'ZalandoSans', fontWeight: '600' }}>
            Developed through pioneering research at NIOSH, patented at Purdue University, and proudly produced in the
            United States. VPSi is designed for precision, reliability, and real-world impact.
          </Typography>
          <Button
            color="error"
            variant="contained"
            size="xlarge"
            onClick={() => setOpen(true)}
            sx={{
              fontWeight: '700',
              fontSize: '30px',
              borderRadius: '100px',
              padding: '10px 50px',
              fontFamily: 'ZalandoSans',
            }}
          >
            LEARN MORE
          </Button>
        </Box>
        <Box sx={{ maxWidth: '475px', width: '80vw', height: '80vw', maxHeight: '475px', position: 'relative' }}>
          <Box sx={{ bgcolor: 'action.selected', borderRadius: '50%', width: '100%', height: '100%' }} />
          <StyledImage src={Sensor} alt="VPSi Sensor" />
        </Box>
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95vw', md: '70vw' },
            maxWidth: '900px',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              top: -18,
              right: -18,
              zIndex: 1,
              bgcolor: 'error.main',
              color: 'white',
              '&:hover': { bgcolor: 'error.dark' },
              width: 36,
              height: 36,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
            <iframe
              src={open ? 'https://www.youtube.com/embed/aEvZfGftuEU?autoplay=1' : ''}
              title="VPSi Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '8px',
              }}
            />
          </Box>
        </Box>
      </Modal>
    </Container>
  );
}
